import { render, staticRenderFns } from "./fieldset.vue?vue&type=template&id=638a1259&"
import script from "./fieldset.vue?vue&type=script&lang=js&"
export * from "./fieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports